export const OperationalOptimizationsActionTypes = {
    API_RESPONSE_SUCCESS: '@@operational-optimizations/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@operational-optimizations/API_RESPONSE_ERROR',
    GET_GROUND_VS_AIR: '@@operational-optimizations/GET_GROUND_VS_AIR',
    GET_OPTIMIZED_GROUND_VS_AIR: '@@operational-optimizations/GET_OPTIMIZED_GROUND_VS_AIR',
    GET_GROUND_VS_AIR_DETAILS: '@@operational-optimizations/GET_GROUND_VS_AIR_DETAILS',
    GET_OPTIMIZED_GROUND_VS_AIR_DETAILS: '@@operational-optimizations/GET_OPTIMIZED_GROUND_VS_AIR_DETAILS',
};
